module.exports = __webpack_public_path__ + "static/img/bar_ico.ff2d40b7.svg";